export default function dashboard(axios: any) {
  const getUsersStats = async () => {
    const result = await axios.get('/users/stats');
    try {
      if (result.status === 200) {
        return result.data.data;
      }
    } catch (error) {
      console.error('[/api/dashboard.ts] getUsersStats error');
    }
    return null;
  };

  return {
    getUsersStats,
  };
}
